<template>
  <v-layout row justify-center v-if="dialog">
    <v-dialog v-model="dialog" persistent max-width="290">
      <!-- <v-btn color="primary" dark slot="activator">Open Dialog</v-btn> -->
      <v-card>
        <v-card-title class="headline">Mazanie hrobu</v-card-title>
        <v-card-text>Ste si istý, že chcete definitívne zmazať hrob ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="dialog = false" @click="deleteGrave()">Zmazať hrob</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false, isDialog=false">Zrušiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'DeleteGraveModal',
  props: ['isDialog'],
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    deleteGrave: function () {
      this.$emit('deleteGrave')
    }
  },
  watch: {
    isDialog: function (newVal, oldVal) {
      this.dialog = newVal
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeleteGraveModal.vue